import { jsx as u, jsxs as S, Fragment as Q } from "../../_virtual/jsx-runtime.mjs";
import * as t from "react";
import x from "./CommonVideo.mjs";
import { PlayIcon as X } from "./Icon.mjs";
import Z from "../ReoYoutube/ReoYoutube.mjs";
import z from "../../depend/classnames/index.mjs";
import { youtubeBtn as $, youtubeImg as U } from "./css/Media.css.mjs";
import { u as D, e as p } from "../../packages/utils/dist/useIntersectionObserver-1ee6520e.mjs";
import W from "./Image.mjs";
import { DEFAULT_SCREEN_BREAKPOINT as j, isPcSameM as ee, EVideoReadyState as oe } from "./const.mjs";
import ne from "../../utils/getGlobal.mjs";
import se from "./hooks/useShowControl.mjs";
const be = t.forwardRef((o, F) => {
  const H = o.breakpoint ?? j, { showAboveBreakpoint: O, showBelowBreakpoint: Y, styleNode: G } = se(H), e = t.useMemo(() => {
    var s;
    return (s = o.youtube) == null ? void 0 : s.pc;
  }, [o.youtube]), r = t.useMemo(() => {
    var s;
    return (s = o.youtube) == null ? void 0 : s.m;
  }, [o.youtube]), d = t.useMemo(() => {
    var l;
    const s = (l = o.youtube) == null ? void 0 : l.m;
    return ee(s);
  }, [o]), C = D(), N = t.useMemo(() => C < (o.breakpoint ?? j), [o.breakpoint, C]), i = t.useRef(null), y = t.useRef(null), [n, K] = t.useState({ current: null }), c = t.useCallback(() => {
    var P, w, A, V;
    const s = ((P = n.current) == null ? void 0 : P.currentTime) && ((w = n.current) == null ? void 0 : w.currentTime) > 0 && !((A = n.current) != null && A.paused) && !((V = n.current) != null && V.ended), l = () => {
      var _;
      (_ = n.current) == null || _.play().then(() => {
        var a;
        (a = n.current) == null || a.removeEventListener("canplay", c);
      }).catch((a) => {
        console.error(a);
      });
    };
    n.current && !s && (n.current.readyState && n.current.readyState >= oe.HAVE_CURRENT_DATA ? l() : n.current.addEventListener("canplay", c));
  }, [n]), m = t.useCallback(() => {
    n.current && n.current.pause();
  }, [n]);
  t.useEffect(() => {
    const s = N ? d ? i : y : i;
    K((l) => (l !== s && (i.current && (i.current.currentTime = 0), y.current && (y.current.currentTime = 0), m()), s));
  }, [N, d, m]), t.useImperativeHandle(
    F,
    () => ({
      el: n.current,
      play: c,
      pause: m
    }),
    [m, c, n]
  );
  const h = t.useMemo(() => o.videoBtnSize ?? "medium", [o.videoBtnSize]), [v, M] = t.useState(e == null ? void 0 : e.loop), k = t.useCallback(() => {
    var s;
    (s = n.current) == null || s.play().catch((l) => {
      console.error(l);
    }), e != null && e.loop && M(!0);
  }, [e == null ? void 0 : e.loop, n]), R = t.useCallback(() => {
    const s = n.current;
    s && !(e != null && e.autoplay) && (s.currentTime = 0, s.pause(), M(!1));
  }, [e == null ? void 0 : e.autoplay, n]), g = t.useMemo(() => v ?? (e == null ? void 0 : e.loop) ?? !1, [v, e == null ? void 0 : e.loop]), [q, E] = t.useState(!1), b = t.useCallback(() => {
    var s, l;
    e != null && e.youtubeSrc && (E(!0), (l = (s = ne()).gtag) == null || l.call(s, "open-youtube-video", "click", {
      videoId: e == null ? void 0 : e.youtubeSrc
    }));
  }, [e == null ? void 0 : e.youtubeSrc]), T = t.useMemo(() => z($, o.btnClassName), [o.btnClassName]), f = t.useMemo(
    () => e != null && e.youtubeSrc ? /* @__PURE__ */ u(
      X,
      {
        className: T,
        style: o.btnStyle,
        size: h,
        onClick: b
      }
    ) : null,
    [T, e == null ? void 0 : e.youtubeSrc, b, o.btnStyle, h]
  ), J = t.useCallback(() => {
    E(!1);
  }, []), I = t.useMemo(
    () => ({
      commonClassName: o.commonClassName,
      commonStyle: o.commonStyle,
      className: o.className,
      style: o.style,
      loop: g,
      ref: n,
      onWrapMouseEnter: k,
      onWrapMouseLeave: R,
      icon: f,
      children: o.children
    }),
    [
      k,
      R,
      f,
      g,
      o.children,
      o.className,
      o.commonClassName,
      o.commonStyle,
      o.style,
      n
    ]
  ), B = t.useMemo(
    () => ({
      commonClassName: o.commonClassName,
      commonStyle: o.commonStyle,
      className: o.className,
      style: o.style
    }),
    [o.className, o.commonClassName, o.commonStyle, o.style]
  ), L = p(n, o.threshold);
  return t.useEffect(() => {
    const s = n.current;
    e != null && e.autoplay && s && (L ? c() : (m(), s.currentTime = 0));
  }, [L, m, e == null ? void 0 : e.autoplay, c, n]), /* @__PURE__ */ S(Q, { children: [
    G,
    /* @__PURE__ */ u(
      "div",
      {
        style: o.style,
        onClick: b,
        className: z({ [O]: !d }),
        children: e != null && e.src ? /* @__PURE__ */ u(
          x,
          {
            ...I,
            ref: i,
            poster: e == null ? void 0 : e.poster,
            src: e == null ? void 0 : e.src
          }
        ) : /* @__PURE__ */ S("div", { className: U, children: [
          /* @__PURE__ */ u(
            W,
            {
              ...B,
              image: { pc: { src: e == null ? void 0 : e.poster } }
            }
          ),
          f
        ] })
      }
    ),
    d ? null : /* @__PURE__ */ u(
      "div",
      {
        style: o.style,
        className: Y,
        children: r != null && r.src ? /* @__PURE__ */ u(
          x,
          {
            ...I,
            ref: y,
            poster: r == null ? void 0 : r.poster,
            src: r == null ? void 0 : r.src
          }
        ) : /* @__PURE__ */ S("div", { className: U, children: [
          /* @__PURE__ */ u(
            W,
            {
              ...B,
              image: { pc: { src: r == null ? void 0 : r.poster } }
            }
          ),
          f
        ] })
      }
    ),
    /* @__PURE__ */ u(
      Z,
      {
        open: q,
        options: { videoId: (e == null ? void 0 : e.youtubeSrc) ?? "" },
        onClose: J
      }
    )
  ] });
});
export {
  be as default
};
//# sourceMappingURL=Youtube.mjs.map
